// Bilingual content for Innospeq site (DE / EN)
import { STOCK_IMAGE_URLS } from "./constants/assets";
export const translations = {
  de: {
    nav: {
      problem: "Problem",
      solution: "Lösung",
      advantages: "Vorteile",
      usecases: "Einsatzgebiete",
      contact: "Demo",
      app: "Zur App",
    },
    hero: {
      eyebrow: "KI für Sicherheit & Compliance",
      titleA: "Sicherheitsbegehungen",
      titleB: "sind Pflicht.",
      titleC: "Wirtschaftlichkeit",
      titleD: "ist es auch.",
      stat: "750.000+",
      statLabel: "Arbeitsunfälle pro Jahr in Deutschland",
      statSource: "Quelle: Deutsche Gesetzliche Unfallversicherung – DGUV",
      lead: "Jeder Unfall zeigt: Arbeitssicherheit ist kein Nebenthema. Unternehmen brauchen Prozesse, mit denen Risiken frühzeitig erkannt, dokumentiert und konsequent nachverfolgt werden.",
      value: "Bis zu 80 % weniger Zeitaufwand dank innospeq, der KI-gestützten Plattform für Sicherheitsbegehungen, Inspektionen, automatische Dokumentation und transparente Maßnahmenverfolgung. ",
      ctaPrimary: "Demo buchen",
      ctaSecondary: "Pilotprojekt starten",
      badgeLive: "DSGVO-konform",
      trustPanel: {
        eyebrow: "Vertrauen durch Sicherheit",
        title: "Ihre Daten. Ihre Verantwortung.",
        titleAccent: "Unsere Verpflichtung.",
        items: [
          {
            title: "DSGVO-konform",
            desc: "Datenschutz nach europäischen Standards",
          },
          {
            title: "Hosting in Europa",
            desc: "Serverstandorte ausschließlich innerhalb der EU",
          },
          {
            title: "Professionelle Dokumentation",
            desc: "Vollständiger Audit-Trail für jede Begehung",
          },
          {
            title: "Nachvollziehbare KI",
            desc: "Empfehlungen mit Bezug auf relevante Regelwerke",
          },
        ],
        footer: "Entwickelt für die Anforderungen des deutschen und europäischen Arbeitsschutzrechts.",
        link: "Mehr erfahren",
      },
      marquee: {
        items: [
          // { icon: "shield", label: "ISO 45001 ready" },
          // { icon: "layers", label: "Multi-Site" },
          { icon: "eye", label: "KI-Vision" },
          { icon: "fileCheck", label: "DSGVO" },
          { icon: "zap", label: "Bis zu 80% schneller" },
          { icon: "clipboardCheck", label: "Audit-Trail" },
          { icon: "gavel", label: "Rechts- & regelbasierte KI" },
        ],
        madeIn: "— made in Germany",
      },
    },
    problem: {
      eyebrow: "Das Problem",
      title: "Sicherheit ist Pflicht. Der Aufwand dafür ist heute oft unnötig hoch.",
      lead: "Sicherheitsbegehungen sind ein zentrales Instrument zur Unfallvermeidung. Sie sind gesetzlich vorgeschrieben und unverzichtbar für den Schutz von Mitarbeitenden.",
      sub: "Doch in der Praxis sind sie häufig:",
      points: [
        "zeitaufwendig und personalintensiv",
        "stark manuell geprägt",
        "fehleranfällig in der Dokumentation",
        "schwer skalierbar über mehrere Standorte",
      ],
      key: "Innospeq senkt den Aufwand für Sicherheitsbegehungen drastisch und reduziert damit operative Kosten erheblich.",
    },
    problemInsight: {
      eyebrow: "Das Problem",
      titleA: "Das eigentliche Problem ist nicht die Begehung.",
      titleB: "Es ist das, was danach passiert.",
      lead: "Safety-Teams fehlt es nicht an Aufmerksamkeit. Es fehlt an Zeit, Struktur und verlässlicher Nachverfolgung.",
      sub: "In der Praxis sind Begehungen oft:",
      cards: [
        {
          title: "Manuell",
          desc: "Fotos, Notizen und Erkenntnisse werden an unterschiedlichen Orten gesammelt.",
        },
        {
          title: "Zeitaufwendig",
          desc: "Berichte und Dokumentation dauern länger als die Begehung selbst.",
        },
        {
          title: "Schwer nachzuverfolgen",
          desc: "Maßnahmen gehen zwischen E-Mails, Excel-Dateien und Zuständigkeiten verloren.",
        },
        {
          title: "Schwer nachzuweisen",
          desc: "Wenn Audits stattfinden, sind Nachweise oft verstreut oder unvollständig.",
        },
      ],
      insight: "Nicht erkannte Risiken sind kein Zufall – sie sind ein Prozessproblem.",
    },
    risk: {
      eyebrow: "Risiko & Verantwortung",
      title: "Verantwortung endet nicht beim Rundgang",
      lead: "Unternehmen sind verpflichtet, Gefährdungen systematisch zu erkennen, zu bewerten und zu dokumentieren.",
      sub: "Werden Risiken übersehen oder nicht konsequent nachverfolgt, entstehen:",
      points: [
        { title: "Haftungsrisiken", desc: "für Management und Geschäftsführung" },
        { title: "Audit-Probleme", desc: "bei Behördenprüfungen und Zertifizierungen" },
        { title: "Mangelnde Transparenz", desc: "über offene Maßnahmen und Verantwortliche" },
        { title: "Schwere Unfälle", desc: "potenziell vermeidbare Ereignisse" },
      ],
      key: "Nicht erkannte Risiken sind kein Zufall – sie sind ein Prozessproblem.",
    },
    break: {
      eyebrow: "Der Bruch",
      title: "Die entscheidende Frage ist nicht, ob Sie prüfen – sondern wie effizient Sie es tun.",
      lead: "Sicherheitsbegehungen bleiben unverzichtbar. Doch der klassische Ansatz ist nicht mehr zeitgemäß.",
      sub: "Unternehmen brauchen eine Lösung, die:",
      points: [
        "Risiken frühzeitig sichtbar macht",
        "Dokumentation automatisiert",
        "Maßnahmen konsequent nachverfolgbar macht",
        "und gleichzeitig den Aufwand drastisch reduziert",
      ],
    },
    solution: {
      eyebrow: "Die Lösung",
      title: "Andere KIs erkennen Objekte - innospeq versteht Arbeitsschutz.",
      lead: "Unsere Plattform digitalisiert und unterstützt Sicherheitsbegehungen durch die Analyse von Arbeitsumgebungen auf Grundlage relevanter gesetzlicher und technischer Vorgaben, darunter **Technische Regeln der BAuA, DGUV-Vorschriften sowie deutsche und europäische Rechtsvorschriften**. Zusätzlich können interne Dokumente, Betriebsanweisungen und unternehmensspezifische Vorgaben hochgeladen werden, sodass die Analyse auch individuelle Unternehmensanforderungen berücksichtigt.",
      result: "Das Ergebnis:",
      points: [
        { title: "Schnellere Begehungen", desc: "Bis zu 80 % weniger Aufwand pro Rundgang." },
        { title: "Strukturierte Risikoerkennung", desc: "Bewertungen auf Rechtsbasis und unternehmensinternen Vorgaben." },
        //{ title: "Duplikate vermeiden", desc: "Bestehende Risiken werden automatisch zusammengeführt, sodass doppelte Einträge vermieden werden." },
        { title: "Automatische Berichte und Auswertungen", desc: "Statistiken und transparente Dokumentation per Klick." },
        { title: "Transparente Maßnahmen", desc: "Aufgaben, Owner, Status – alles sichtbar." },
      ],
      key: "Mehr Sicherheit. Weniger Aufwand. Klare Nachverfolgbarkeit.",
    },
    how: {
      eyebrow: " Alles in einer Plattform.",
      titlePrefix: "So einfach funktioniert ",
      titleHighlight: "innospeq",
      titleSuffix: "",
      subtitle: "Von der Begehung bis zum Maßnahmenmanagement",
      steps: [
        {
          title: "Begehung durchführen",
          lead: "Fotos aufnehmen, Notizen erfassen.",
          desc: "Direkt vor Ort mit Smartphone oder Tablet, ob risikoorientierte Begehung oder standardisierte Checkliste. Alles in einer App.",
        },
        {
          title: "KI bewertet nach Vorschrift",
          lead: "Gefährdungen automatisch analysieren.",
          desc: "Analyse auf Basis der relevanten Arbeitsschutzvorschriften. Nachvollziehbare Bewertungen statt allgemeiner Vermutungen.",
        },
        {
          title: "Freigabe und Berichtserstellung",
          lead: "Mit nur einem Klick dokumentiert.",
          desc: "Nach der Freigabe durch Ihre Expertise werden Fotos, Bewertungen und Erkenntnisse zu einem vollständigen Bericht zusammengeführt.",
        },
        {
          title: "Maßnahmen zuweisen",
          lead: "Verantwortlichkeiten festlegen.",
          desc: "Aufgaben werden direkt den richtigen Personen zugewiesen – inklusive Fristen und Prioritäten.",
        },
        {
          title: "Umsetzung nachverfolgen",
          lead: "Alles im Blick bis zum Abschluss.",
          desc: "Verfolgen Sie den Status jeder Maßnahme und bleiben Sie jederzeit handlungsbereit.",
        },
      ],
      result: [
        { title: "Ergebnis: Mehr Sicherheit. Weniger Aufwand." },
        { title: "Bis zu 80% weniger Aufwand" },
        { title: "Einheitliche Bewertungsstandards." },
        { title: "Transparenz über Standorte hinweg" },
      ],
    },
    advantages: {
      eyebrow: "Vorteile",
      title: "Warum Innospeq",
      items: [
        { title: "Regelwerksgestützte Analyse", desc: "Erkenntnisse basieren auf relevanten Arbeitsschutzvorschriften statt auf generischen KI-Modellen." },
        { title: "Bis zu 80% Zeitersparnis", desc: "Weniger Nacharbeit – mehr Fokus auf zentrale Aufgaben." },
        { title: "Auswertbare Ergebnisse", desc: "Klare Visualisierungen statt Fließtext. Fortschritt tracken." },
        { title: "Spaß bei der Arbeit", desc: "Berichte schreiben wird leicht – effizient und motivierend." },
      ],
    },
    available: {
      eyebrow: "Stets verfügbar",
      title: "Eine Plattform. Jedes Endgerät.",
      desc: "Als Web-App ist innospeq überall nutzbar – auf der Baustelle am Smartphone, im Meeting auf dem Tablet oder im Büro am Desktop. Keine Installation. Immer up to date.",
      bullets: ["Mobile-first", "Offline-fähig", "Cloud-Synchronisation"],
    },
    usecases: {
      eyebrow: "Vielseitig einsetzbar",
      title: "Für vielfältige Branchen gemacht",
      items: [
        { title: "Baugewerbe", img: STOCK_IMAGE_URLS.construction, desc: "Maschinen- und Gerätesicherheit, Absturz- und Rutschrisiken, fehlende Schutzeinrichtungen, ergonomische Risiken." },
        { title: "Verwaltung / Dienstleistungssektor", img: STOCK_IMAGE_URLS.office, desc: "Arbeitssicherheit, Rutsch- und Stolpergefahren, ergonomische Bedingungen." },
        { title: "Produzierendes Gewerbe", img: STOCK_IMAGE_URLS.production, desc: "Beschädigungen, offensichtliche Defekte, Warnhinweise, Sauberkeit und Ordnung am Arbeitsplatz, PSA." },
        { title: "Logistik- und Transportbranche", img: STOCK_IMAGE_URLS.logistics, desc: "Sicherheit entlang der Transportkette, Be- und Entladevorgänge, Ordnung und Sauberkeit." },
        { title: "… und mehr", img: STOCK_IMAGE_URLS.mall, desc: "Wir entwickeln kontinuierlich neue Funktionen – für jeden Arbeitsplatz." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Häufige Fragen zu innospeq",
      desc: "Alles Wichtige zu KI-Analyse, Regelwerken, Datenschutz und der Nutzung von innospeq.",
      items: [
        {
          question: "Was ist innospeq und wie unterstützt die Anwendung bei der Arbeitssicherheit?",
          answer:  [
            "Innospeq ist eine webbasierte Softwareplattform für Arbeitssicherheit und unterstützt unter anderem bei Sicherheitsbegehungen und Gefährdungsbeurteilungen. Ziel ist es das Fachpersonal durch KI von Routinetätigkeiten zu entlasten.",
            "Bei Arbeitssicherheitsbegehungen beispielsweise können Fotos mithilfe von KI unter Berücksichtigung der relevanten Vorschriften analysiert werden. Das Analyseergebnis umfasst erkannte Gefährdungen, vorgeschlagene Schutzmaßnahmen, mit Verweisen auf die entsprechenden rechtlichen Hintergründe.",
            "Die von der KI erzeugten Analyseergebnisse dienen dabei als Vorschläge und können jederzeit bearbeitet, ergänzt oder gelöscht werden. Die abschließende Freigabe erfolgt durch eine fachlich qualifizierte Person.",
            "Die daraus abgeleiteten konkreten Schutzmaßnahmen können systematisch nachverfolgt werden. Darüber hinaus lassen sich übersichtliche PDF-Berichte und Auswertungen automatisiert erstellen. \n Auch in weiteren Anwendungsbereichen unterstützt die KI die Anwender stark bei der täglichen Arbeit.",
          ],
        },
        {
          question: "Ersetzt die KI von innospeq eine Fachkraft für Arbeitssicherheit?",
          answer: [
            "Die KI von innospeq analysiert die Daten auf Grundlage relevanter gesetzlicher und technischer Vorgaben.",
            "Die von der KI erzeugten Analyseergebnisse dienen als Vorschläge und können jederzeit bearbeitet, ergänzt oder gelöscht werden. Trotz der hohen Qualität der Ergebnisse kann es vorkommen, dass Sachverhalte nicht erkannt, falsch bewertet oder anderweitig fehlerhaft beurteilt werden. Daher muss eine abschließende Prüfung und Freigabe durch eine fachlich qualifizierte Person erfolgen. Die Verantwortung verbleibt bei der zuständigen Fachperson beziehungsweise beim Unternehmen.",
            "innospeq ersetzt daher keine Fachkraft für Arbeitssicherheit, sondern unterstützt bei der Durchführung und Dokumentation.",
          ],
        },
        {
          question: "Welche Regelwerke und betrieblichen Vorgaben werden berücksichtigt?",
          answer: [
            "innospeq berücksichtigt Technische Regeln der BAuA, DGUV-Vorschriften sowie deutsche und europäische Rechtsvorschriften.",
            "Bei erkannten Gefährdungen werden die detaillierten rechtlichen Hintergründe und aufgeführt. ",
          ],
        },
        {
          question: "Wo werden die Daten gespeichert und wie werden Bilder geschützt?",
          answer: [
            "Alle Server von innospeq befinden sich innerhalb der Europäischen Union. Bei Interesse geben wir hierzu gerne eine detaillierte Auskunft. Der Schutz Ihrer Daten ist uns besonders wichtig.",
            "Aufgenommene Bilder werden beim Start der Verarbeitung auf Gesichter geprüft, erkannte Gesichter werden dann unkenntlich gemacht.",
            "Hochgeladene Bilder, Dokumente und Projektdaten werden ausschließlich zur Bereitstellung der vereinbarten Funktionen verarbeitet und nicht für das allgemeine Training von KI-Modellen verwendet. ",
          ],
        },
        {
          question:"Worauf sollte beim Aufnehmen von Fotos geachtet werden?",
          answer: [
            "Je besser ein möglicher Mangel auf dem Foto erkennbar ist, desto besser kann die KI ihn analysieren. Fotos sollten deshalb möglichst gezielt auf relevante Bereiche, Arbeitsmittel oder konkrete Auffälligkeiten ausgerichtet sein.",
            "Weitwinklige Aufnahmen, die lediglich allgemein in einen Raum hinein fotografieren, sind für die Analyse meist weniger hilfreich. Sinnvoller sind klare, ausreichend nahe Aufnahmen, auf denen die betreffende Situation gut zu erkennen ist. Bei Bedarf können auch mehrere Fotos aus unterschiedlichen Perspektiven aufgenommen werden.",
            "Menschen dürfen auf den Bildern zu sehen sein. Das kann die Analyse in bestimmten Situationen sogar unterstützen, beispielsweise wenn Körperhaltung, Arbeitsweise oder der Umgang mit Arbeitsmitteln relevant sind. Gesichter werden bereits vor der KI-Analyse anonymisiert.",
          ],
        },
        {
          question:"Warum analysiert innospeq Bilder statt Videos? ",
          answer: [
            "Die Analyse von Videos ist ein separater Anwendungsfall, bei dem es darum geht, in Echtzeit zu überprüfen, ob Sicherheitsmaßnahmen eingehalten werden – etwa ob die erforderliche persönliche Schutzausrüstung (PSA) getragen wird oder ob Gabelstapler mit abgesenkter Gabel fahren.",
            "Der Schwerpunkt von innospeq liegt hingegen darauf, Gefährdungen frühzeitig zu erkennen und geeignete Schutzmaßnahmen abzuleiten. Dafür werden einzelne Bilder sehr gründlich durch die KI analysiert. Die daraus entstehenden Analyseergebnisse werden anschließend von einer fachlich qualifizierten Person geprüft und freigegeben.",
          ],
        },
        {
          question: "Welche Geräte und Browser werden unterstützt? Muss eine App installiert werden?",
          answer: [
            "innospeq ist eine Web-Anwendung und funktioniert in allen modernen Browsern. Eine separate Installation auf dem Computer, Tablet oder Smartphone ist nicht erforderlich.",
            "Die Anwendung kann sowohl am Desktop als auch mobil genutzt werden. Auf dem Smartphone lassen sich Fotos direkt innerhalb von innospeq aufnehmen und unmittelbar analysieren. Dadurch können Begehungen direkt vor Ort durchgeführt und dokumentiert werden.",
          ],
        },
        {
          question: "Können eigene Checklisten und Vorlagen erstellt werden?",
          answer: [
            "Ja. Eigene Checklisten können an betriebliche Abläufe, Standorte und individuelle Prüfanforderungen angepasst werden.",
            "Bereits vorhandene Dokumente, beispielsweise PDF- oder Word-Dateien, können als Grundlage für neue Vorlagen verwendet werden. Alternativ lassen sich Checklisten mithilfe von LexHub erstellen und anschließend weiter anpassen.",
          ],
        },
        {
          question: "Können Aufgaben verwaltet und Teammitgliedern zugeordnet werden?",
          answer: [
            "Ja. Aus dokumentierten Gefährdungen werden konkrete Aufgaben/Schutzmaßnahmen abgeleitet.",
            "Für jede Aufgabe können eine zuständige Person, eine Frist und ein Bearbeitungsstatus festgelegt werden. Die Darstellung erfolgt übersichtlich in den Bereichen „To do“, „In Progress“ und „Done“. Überfällige, offene und erledigte Aufgaben sind direkt erkennbar.",
            "Im Bereich „Meine Aufgaben“ werden alle persönlich zugewiesenen Maßnahmen projektübergreifend an einem zentralen Ort gebündelt.",
          ],
        },
        {
          question: "Können Berichte an das eigene Unternehmen angepasst werden?",
          answer: [
            "Ja. Der Standardbericht kann mit dem eigenen Unternehmenslogo individualisiert werden.",
            "Werden darüber hinaus besondere Inhalte, Strukturen oder Layouts benötigt, kann das innospeq-Team individuelle Berichtsvorlagen erstellen und direkt in der Anwendung bereitstellen.",
            "In den Berichten lassen sich unter anderem Titel, Beschreibung, betroffene Bereiche, verantwortliche Personen und weitere Teilnehmende erfassen. Zusätzlich kann ausgewählt werden, ob Schutzmaßnahmen enthalten und der Bericht als geprüft und freigegeben gekennzeichnet werden soll. Der fertige Bericht wird als PDF ausgegeben.",
          ],
        },
        {
          question: "Kann innospeq vor dem Kauf getestet werden?",
          answer: [
            "Ja, wir sind von unserem Produkt überzeugt und freuen uns über jeden, der innospeq testen möchte. Für einen begleiteten Proof Of Concept bzw. Testzugang kann das innospeq-Team direkt über den Kontaktbereich der Website angesprochen werden.",
            "Während des Tests lassen sich die zentralen Funktionen im eigenen Arbeitskontext kennenlernen – von der Aufnahme und Analyse von Bildern über die Bearbeitung erkannter Gefährdungen bis zur Verwaltung von Schutzmaßnahmen und Erstellung eines PDF-Berichts.",
          ],
          cta: { label: "Testzugang anfragen", href: "#contact" },
        },
      ],
    },
    contact: {
      eyebrow: "Kostenlose Demo",
      title: "Sehen Sie Innospeq in Aktion.",
      desc: "Hinterlassen Sie uns eine Nachricht – wir melden uns innerhalb eines Werktags.",
      name: "Name",
      namePh: "Ihr vollständiger Name",
      email: "E-Mail-Adresse",
      emailPh: "name@unternehmen.de",
      phone: "Telefon",
      phonePh: "(0123) 456-7890",
      message: "Nachricht",
      messagePh: "Worum geht es?",
      submit: "Anfrage senden",
      submitting: "Wird gesendet…",
      success: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
      consent: "Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.",
      info: [
        { label: "E-Mail", value: "info@innospeq.com" },
        { label: "Standort", value: "Deutschland" },
        { label: "Antwort", value: "< 24h" },
      ],
    },
    footer: {
      tagline: "KI-gestützte Sicherheitsbegehungen für moderne Unternehmen.",
      product: "Produkt",
      company: "Unternehmen",
      legal: "Rechtliches",
      links: {
        features: "Funktionen",
        app: "Zur App",
        pricing: "Preise",
        about: "Über uns",
        linkedin: "Zu LinkedIn",
        careers: "Karriere",
        disclaimer: "Haftungsausschluss",
        privacy: "Datenschutz",
        imprint: "Impressum",
        terms: "AGB",
      },
      rights: "Alle Rechte vorbehalten.",
    },
    pricing: {
      back: "Zurück",
      eyebrow: "Preise",
      title: "Pakete für Sifas und Organisationen.",
      lead: "Wählen Sie den passenden Einstieg für digitale Sicherheitsbegehungen, KI-gestützte Auswertungen und transparente Maßnahmenverfolgung.",
      badge: "Beliebt",
      introductoryPrice: "Einführungspreis",
      included: "Inkludiert",
      features: "Features",
      plans: [
        {
          name: "Core",
          ideal: "Ideal für einzelne Sicherheitsfachkräfte",
          price: "69 €",
          period: "pro Monat / Editor-Benutzer",
          cta: "Kontakt aufnehmen",
          href: "/#contact",
          primary: true,
          features: [
            { label: "Benutzer", value: "1 Editor-Benutzer" },
            { label: "Projekte", value: "25 Projekte" },
            { label: "Bildanalysen", value: "100 Bildanalysen / Monat inklusive" },
            { label: "KI-Funktionen", value: "KI-gestützte Bildanalyse" },
            { label: "Verwaltung & Sicherheit", value: "Basis-Verwaltungs & Sicherheitsfunktionen" },
            { label: "Support", value: "Standard Support" },
          ],
        },
        {
          name: "Enterprise",
          ideal: "Ideal für Organisationen & mehrere Standorte",
          price: "199 €",
          period: "pro Monat / Editor-Benutzer",
          cta: "Kontakt aufnehmen",
          href: "/#contact",
          primary: true,
          features: [
            { label: "Benutzer", value: "Individuell vereinbar + unbegrenzte Viewer-Benutzer" },
            { label: "Projekte", value: "Unbegrenzte Projekte" },
            { label: "Bildanalysen", value: "400 Bildanalysen / Monat inklusive" },
            { label: "KI-Funktionen", value: "KI-Agent + Empfehlungen auf Basis relevanter Normen und Regelwerke" },
            { label: "Verwaltung & Sicherheit", value: "SSO, Audit Trail, private Instanz" },
            { label: "Support", value: "Premium Support mit persönlichem Ansprechpartner" },
          ],
        },
      ],
      note: "Sollte keines der Pakete Ihren Anforderungen entsprechen, bieten wir individuelle Lösungen an. Bitte kontaktiert uns, um eure Anforderungen zu besprechen.",
      addOns: {
        title: "Add-on-Pakete",
        desc: "Optional zubuchbare Bildanalysen für beide Pakete.",
        items: [
          { label: "+100 Bildanalysen", value: "49,- €", rate: "(0,49 € / Bild)" },
          { label: "+500 Bildanalysen", value: "225,- €", rate: "(0,45 € / Bild)" },
          { label: "+1.000 Bildanalysen", value: "390,- €", rate: "(0,39 € / Bild)" },
        ],
      },
      comparison: {
        title: "Pläne vergleichen",
        rows: [
          { label: "Nutzung & Limits", section: true },
          // { label: "Preis", core: "69,- / Monat / Benutzer", enterprise: "999,- / Monat / Standort" },
          { label: "Editor-Benutzer", core: "1 aktiver Benutzer", enterprise: "Individuell vereinbar" },
          { label: "Viewer-Benutzer", core: "minus", enterprise: "Unbegrenzt" },
          { label: "Projekte", core: "25", enterprise: "Unbegrenzt" },
          { label: "Bildanalysen pro Monat", core: "100 / Monat", enterprise: "400 / Monat" },
          { label: "Preis pro Bildanalyse", core: "0,69 € / Bild", enterprise: "0,50 € / Bild" },
          { label: "Add-on Bildanalysen", core: "check", enterprise: "check" },

          { label: "Begehungen & Mängelmanagement", section: true },
          { label: "Risikofokussierte Sicherheitsbegehungen", core: "check", enterprise: "check" },
          { label: "Checklisten", core: "check", enterprise: "check" },
          { label: "Eigene Checklisten-Vorlagen", core: "check", enterprise: "check" },
          { label: "Mängel erfassen und Aufgaben zuweisen", core: "check", enterprise: "check" },
          // { label: "Externe Mängelzuweisung", core: "check", enterprise: "minus" },
          { label: "Automatische Duplikaterkennung", core: "check", enterprise: "check" },
          { label: "PDF-Reports", core: "check", enterprise: "check" },
          { label: "Anonymisierung von Gesichtern", core: "check", enterprise: "check" },
          { label: "E-Mail-Benachrichtigungen", core: "check", enterprise: "check" },

          { label: "KI & Regelwerksbezug", section: true },
          { label: "KI-gestützte Bildanalyse", core: "check", enterprise: "check" },
          { label: "Handlungsempfehlungen auf Basis relevanter Normen und Regelwerke", core: "check", enterprise: "check" },
          { label: "KI-Agent für Enterprise", core: "minus", enterprise: "check" },
          { label: "Gefährdungsbeurteilungen", core: "minus", enterprise: "Coming soon" },

          { label: "Auswertungen", section: true },
          { label: "Projektauswertungen", core: "check", enterprise: "check" },
          { label: "Standort- und organisationsweite Auswertungen", core: "minus", enterprise: "check" },

          { label: "Sicherheit & Organisation", section: true },
          { label: "Google Sign-in", core: "check", enterprise: "check" },
          { label: "Microsoft Entra ID SSO", core: "minus", enterprise: "check" },
          // { label: "Rollen / Viewer / Editoren", core: "check", enterprise: "check" },
          { label: "Änderungshistorie / Audit Trail", core: "minus", enterprise: "check" },
          { label: "Hierarchische Organisationsstruktur", core: "minus", enterprise: "check" },
          { label: "Projekte teilen", core: "minus", enterprise: "check" },
          { label: "Private Cloud-Instanz", core: "minus", enterprise: "check" },
          { label: "On-Premises (nach Absprache)", core: "minus", enterprise: "check" },
          { label: "Alle neuen Features automatisch inklusive", core: "minus", enterprise: "check" },

          { label: "Support", section: true },
          { label: "Standard Support", core: "check", enterprise: "check" },
          { label: "Premium Support mit persönlichem Ansprechpartner", core: "minus", enterprise: "check" },
        ],
      },
    },
    about: {
      back: "Zurück",
      eyebrow: "Über uns",
      title: "Wir bauen Sicherheitsprozesse, die im Alltag funktionieren.",
      company: {
        title: "Über unser Unternehmen",
        copy: [
          "Innospeq entwickelt digitale Werkzeuge für moderne Arbeitssicherheit. Unser Fokus liegt darauf, Sicherheitsbegehungen einfacher, schneller und verlässlicher zu machen.",
          "Wir verbinden KI-gestützte Bildanalyse, klare Dokumentation und transparente Maßnahmenverfolgung zu einer Plattform, die Teams im operativen Alltag entlastet.",
        ],
      },
      team: {
        eyebrow: "Unser Team",
        title: "Fünf Perspektiven, ein gemeinsames Ziel.",
        lead: "Unser Team verbindet Produktdenken mit technischer Tiefe.",
        members: [
          {
            title: "Daniel Bettenworth, Geschäftsführer",
            description: "Setzt die strategische Richtung und sorgt dafür, dass Innospeq nah an den Anforderungen unserer Kunden bleibt.",
            alt: "Porträt der Geschäftsführung",
          },
          {
            title: "Jens Dünnermann, KI & Engineering",
            description: "Entwickelt die Analysefunktionen und die technische Plattform hinter unseren automatisierten Begehungen.",
            alt: "Porträt KI & Engineering",
          },
          {
            title: "Patrick Walczok, KI & Engineering",
            description: "Entwickelt die Analysefunktionen und die technische Plattform hinter unseren automatisierten Begehungen.",
            alt: "Porträt KI & Engineering",
          },
          {
            title: "Isabel Pfab, Design",
            description: "Gestaltet die Nutzererfahrung und sorgt dafür, dass komplexe Sicherheitsprozesse in klare, intuitive Workflows übersetzt werden.",
            alt: "Porträt Design",
          },
          {
            title: "Tom Rudolph, Go-to-Market & Growth",
            description: "Bringt Innospeq mit den richtigen Unternehmen ins Gespräch, entwickelt neue Marktchancen und baut Kundenbeziehungen vom ersten Kontakt bis zum erfolgreichen Einstieg auf.",
            alt: "Porträt Go-to-Market & Growth",
          },
        ],
      },
    },
    imprint: {
      back: "Zurück",
      eyebrow: "Rechtliches",
      title: "Impressum",
      sections: [
        {
          title: "Anbieter",
          lines: [
            "Innospeq GmbH",
            "Geschäftsführer Daniel Bettenworth",
            "Falkenrecks Heide 22",
            "33332 Gütersloh",
            "Deutschland",
          ],
        },
        {
          title: "Kontakt",
          lines: ["Telefon: +49 (0)5241 2118216", "E-Mail: info@innospeq.com"],
        },
        {
          title: "Registerangaben",
          lines: [
            "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE460504564",
            "Handelsregister des Amtsgerichtes Gütersloh",
            "Handelsregisternummer: HRB 14373",
          ],
        },
      ],
      additionalSections: [
        {
          title: "EU-Streitschlichtung",
          paragraphs: [
            "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
            "Unsere E-Mail-Adresse finden Sie oben im Impressum.",
          ],
          link: {
            label: "https://ec.europa.eu/consumers/odr/",
            href: "https://ec.europa.eu/consumers/odr/",
          },
        },
        {
          title: "Verbraucherstreitbeilegung/Universalschlichtungsstelle",
          paragraphs: [
            "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
          ],
        },
        {
          title: "Haftung für Inhalte",
          paragraphs: [
            "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.",
            "Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
          ],
        },
        {
          title: "Haftung für Links",
          paragraphs: [
            "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
          ],
        },
        {
          title: "Urheberrecht",
          paragraphs: [
            "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
          ],
        },
      ],
    },
    privacy: {
      back: "Zurück",
      eyebrow: "Rechtliches",
      title: "Datenschutzerklärung",
      sections: [
        {
          title: "1. Verantwortlicher",
          lines: [
            "Innospeq GmbH",
            "Falkenrecks Heide 22",
            "33332 Gütersloh",
            "Deutschland",
            "E-Mail: info@innospeq.de",
          ],
        },
        {
          title: "2. Allgemeine Hinweise",
          paragraphs: [
            "Der Schutz deiner personenbezogenen Daten ist uns ein wichtiges Anliegen. Wir behandeln personenbezogene Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.",
            "Personenbezogene Daten sind alle Daten, mit denen du persönlich identifiziert werden kannst.",
          ],
        },
        {
          title: "3. Erhebung von Daten beim Besuch der Website",
          paragraphs: [
            "Beim Aufruf unserer Website werden durch den Server automatisch folgende Daten erfasst:",
          ],
          items: [
            "IP-Adresse",
            "Datum und Uhrzeit des Zugriffs",
            "Aufgerufene Seite",
            "Browsertyp und -version",
            "Betriebssystem",
            "Referrer-URL",
          ],
        },
        {
          title: "Technische Bereitstellung",
          paragraphs: [
            "Diese Daten sind technisch erforderlich, um die Website korrekt auszuliefern sowie die Stabilität und Sicherheit des Systems zu gewährleisten.",
            "Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO",
          ],
        },
        {
          title: "4. Hosting",
          paragraphs: [
            "Unsere Website wird auf eigenen Servern betrieben, die bei der IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Deutschland angemietet sind.",
            "Ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO besteht.",
          ],
        },
        {
          title: "5. Kontaktformular",
          paragraphs: [
            "Wenn du uns über das Kontaktformular kontaktierst, werden Name, E-Mail-Adresse und Nachricht verarbeitet.",
            "Die Übermittlung erfolgt per E-Mail und dient ausschließlich der Bearbeitung deiner Anfrage.",
            "Rechtsgrundlage:",
          ],
          items: [
            "Art. 6 Abs. 1 lit. b DSGVO",
            "Art. 6 Abs. 1 lit. f DSGVO",
          ],
        },
        {
          title: "6. Cookies",
          paragraphs: [
            "Es werden keine Analyse- oder Marketing-Cookies eingesetzt.",
          ],
        },
        {
          title: "7. Rechte der betroffenen Personen",
          paragraphs: [
            "Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch.",
          ],
        },
        {
          title: "8. Aktualität",
          paragraphs: ["Stand: 07.07.2026"],
        },
      ],
    },
    disclaimer: {
      back: "Zurück",
      eyebrow: "Rechtliches",
      title: "Haftungsausschluss für KI-basierte Bewertungen (innospeq)",
      intro: [
        "Die von innospeq bereitgestellten Auswertungen, Bewertungen und Empfehlungen werden unter Einsatz von Verfahren der Künstlichen Intelligenz (KI) erzeugt. Sie dienen ausschließlich der Unterstützung der Nutzer und ersetzen keine fachkundige Beratung oder Entscheidung durch einen qualifizierten menschlichen Experten.",
      ],
      subheading: "Insbesondere gilt",
      items: [
        "KI-Ergebnisse stellen keine rechtsverbindliche Auskunft und keine abschließende fachliche Bewertung dar.",
        "Vor jeder fachlichen, organisatorischen oder rechtlich relevanten Entscheidung sind die von innospeq generierten Bewertungen zwingend durch eine geeignete qualifizierte Person (z.B. Fachkraft/Experte im jeweiligen Bereich, verantwortliche Führungskraft) zu prüfen, inhaltlich zu bewerten und freizugeben.",
        "Eine unmittelbare oder automatisierte Umsetzung von KI-Ergebnissen ohne menschliche Prüfung ist unzulässig und erfolgt außerhalb des Verantwortungsbereichs von innospeq.",
        "innospeq übernimmt – soweit gesetzlich zulässig – keine Haftung für Schäden, die daraus entstehen, dass KI-basierte Auswertungen oder Empfehlungen ohne angemessene menschliche Prüfung, Bewertung und Freigabe verwendet oder umgesetzt werden. Zwingende gesetzliche Haftungstatbestände bleiben unberührt.",
      ],
    },
  },
  en: {
    nav: {
      problem: "Problem",
      solution: "Solution",
      advantages: "Advantages",
      usecases: "Use cases",
      contact: "Demo",
      app: "Go to App",
    },
    hero: {
      eyebrow: "AI for safety & compliance",
      titleA: "Safety inspections",
      titleB: "are mandatory.",
      titleC: "Cost-efficiency",
      titleD: "is too.",
      stat: "750,000+",
      statLabel: "Workplace accidents per year in Germany",
      statSource: "Source: German statutory accident insurance (DGUV)",
      lead: "Every accident makes it clear: workplace safety is not a side issue. Companies need processes that identify, document and consistently track risks early on.",
      value: "Up to 80% less time spent with innospeq, the AI-powered platform for safety walks, inspections, automated documentation and transparent action tracking.",
      ctaPrimary: "Book a demo",
      ctaSecondary: "Start a pilot",
      badgeLive: "GDPR-compliant",
      trustPanel: {
        eyebrow: "Trust through security",
        title: "Your data. Your responsibility.",
        titleAccent: "Our commitment.",
        items: [
          {
            title: "GDPR-compliant",
            desc: "Data protection according to European standards",
          },
          {
            title: "Hosting in Europe",
            desc: "Server locations exclusively within the EU",
          },
          {
            title: "Professional documentation",
            desc: "Complete audit trail for every inspection",
          },
          {
            title: "Traceable AI",
            desc: "Recommendations with reference to relevant regulatory frameworks",
          },
        ],
        footer: "Developed for the requirements of German and European occupational health and safety law.",
        link: "Learn more",
      },
      marquee: {
        items: [
          // { icon: "shield", label: "ISO 45001 ready" },
          // { icon: "layers", label: "Multi-site" },
          { icon: "eye", label: "AI vision" },
          { icon: "fileCheck", label: "GDPR" },
          { icon: "zap", label: "Up to 80% faster" },
          { icon: "clipboardCheck", label: "Audit trail" },
          { icon: "gavel", label: "Legal & Rule-Based AI" },
        ],
        madeIn: "— made in Germany",
      },
    },
    problem: {
      eyebrow: "The problem",
      title: "Safety is mandatory. The effort behind it doesn't have to be.",
      lead: "Safety inspections are a key tool to prevent accidents. They are required by law and essential to protect employees.",
      sub: "But in practice they are often:",
      points: [
        "time-consuming and labour-intensive",
        "highly manual",
        "error-prone in documentation",
        "hard to scale across multiple sites",
      ],
      key: "Safety doesn't generate direct revenue – but inefficient processes generate substantial cost.",
    },
    problemInsight: {
      eyebrow: "The problem",
      titleA: "The real problem isn't the inspection.",
      titleB: "It's what happens after.",
      lead: "Safety teams don't lack awareness. They lack time, structure and reliable follow-through.",
      sub: "In practice, inspections are often:",
      cards: [
        {
          title: "Manual",
          desc: "Photos, notes and findings are collected in separate places.",
        },
        {
          title: "Time-consuming",
          desc: "Reports and documentation take longer than the inspection itself.",
        },
        {
          title: "Hard to follow up",
          desc: "Actions get lost between emails, Excel files and responsibilities.",
        },
        {
          title: "Difficult to prove",
          desc: "When audits happen, evidence is often scattered or incomplete.",
        },
      ],
      insight: "Unidentified risks aren't accidents of fate — they're a process problem.",
    },
    risk: {
      eyebrow: "Risk & responsibility",
      title: "Responsibility doesn't end with the walk-through",
      lead: "Companies are required to systematically identify, evaluate and document hazards.",
      sub: "When risks are missed or not consistently followed up, you get:",
      points: [
        { title: "Liability risks", desc: "for management and the executive team" },
        { title: "Audit issues", desc: "during inspections and certifications" },
        { title: "Lack of transparency", desc: "over open actions and owners" },
        { title: "Severe accidents", desc: "potentially preventable events" },
      ],
      key: "Unidentified risks aren't accidents of fate – they're a process problem.",
    },
    break: {
      eyebrow: "The break",
      title: "The question isn't whether you inspect – it's how efficiently you do it.",
      lead: "Safety inspections remain essential. But the classic approach is no longer fit for purpose.",
      sub: "Companies need a solution that:",
      points: [
        "surfaces risks early",
        "automates documentation",
        "tracks actions consistently",
        "and drastically reduces the effort",
      ],
    },
    solution: {
      eyebrow: "The solution",
      title: "Other AIs detect objects – innospeq understands safety.",
      lead: "Our platform digitizes and supports safety inspections by analyzing work environments based on relevant occupational health and safety regulations and standards, including **BAuA Technical Rules, DGUV regulations, as well as German and European legislation.** In addition, organizations can upload internal documents, policies, and company-specific requirements, enabling analyses that reflect both applicable legal obligations and internal standards.",
      result: "The result:",
      points: [
        { title: "Faster inspections", desc: "Up to 80% less effort per walk-through." },
        { title: "Structured risk detection", desc: "Assessments based on legal requirements and internal company guidelines." },
        //{ title: "Avoid Duplicates", desc: "Existing risks are automatically merged, preventing duplicate entries." },
        { title: "Automatic reports and evaluations", desc: "Statistics and audit-proof documentation in one click." },
        { title: "Transparent actions", desc: "Tasks, owners, status – all visible." },
      ],
      key: "More safety. Less effort. Clear traceability.",
    },
    how: {
      eyebrow: "everything in one platform",
      titlePrefix: "It's that easy with ",
      titleHighlight: "innospeq",
      titleSuffix: ".",
      subtitle: "From inspection to completed action management.",
      steps: [
        {
          title: "Run the inspection",
          lead: "Take photos, capture notes.",
          desc: "Directly on site with a smartphone or tablet. Whether it's a risk-oriented walk or a standardized checklist. Everything in one app.",
        },
        {
          title: "AI evaluates based on regulations",
          lead: "Analyse hazards automatically.",
          desc: "Analysis based on relevant occupational safety regulations. Traceable assessments instead of general assumptions.",
        },
        {
          title: "Approval and Report Generation",
          lead: "Documentation in one click.",
          desc: "After approval by your experts, photos, assessments and findings are combined into a complete report.",
        },
        {
          title: "Assign actions",
          lead: "Define responsibilities.",
          desc: "Tasks are assigned directly to the right people – including deadlines and priorities.",
        },
        {
          title: "Track implementation",
          lead: "Everything in view until completion.",
          desc: "Track the status of every action and stay prepared at all times.",
        },
      ],
      result: [
        { title: "Result: More safety. Less effort." },
        { title: "Up to 80% less effort" },
        { title: "Clear evaluation standards"},
        { title: "Transparency across all sites" },
      ],
    },
    advantages: {
      eyebrow: "Advantages",
      title: "Why Innospeq",
      items: [
        { title: "Regulation-based Analysis", desc: "Assessments based on relevant occupational safety regulations." },
        { title: "Up to 80% time saved", desc: "Less rework – more focus on what matters." },
        { title: "Comparable results", desc: "Clear visuals instead of long prose. Track progress over time." },
        { title: "Joy at work", desc: "Reports become easy – efficient, pleasant, motivating." },
      ],
    },
    available: {
      eyebrow: "Always available",
      title: "One platform. Every device.",
      desc: "innospeq runs anywhere as a web app – on your phone on site, on a tablet in a meeting, on a desktop in the office. No install. Always up to date.",
      bullets: ["Mobile-first", "Offline-ready", "Cloud sync"],
    },
    usecases: {
      eyebrow: "Versatile",
      title: "Built for a variety of industries",
      items: [
        { title: "Construction", img: STOCK_IMAGE_URLS.construction, desc: "Machine and equipment safety, fall and slip risks, missing safeguards, ergonomic risks." },
        { title: "Administration / Service Sector", img: STOCK_IMAGE_URLS.office, desc: "Workplace safety, slip & trip hazards, ergonomic conditions." },
        { title: "Producing Industry", img: STOCK_IMAGE_URLS.production, desc: "Damage, obvious defects, warning signs, cleanliness and order at the workplace, PPE." },
        { title: "Logistics and Transportation", img: STOCK_IMAGE_URLS.logistics, desc: "Safety along the transport chain, loading and unloading, clear communication." },
        { title: "… and more", img: STOCK_IMAGE_URLS.mall, desc: "We continuously develop new features – for every workplace." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions about innospeq",
      desc: "Everything you need to know about AI analysis, regulations, data protection, and using innospeq.",
      items: [
        {
          question: "What is innospeq, and how does it support occupational safety?",
          answer:  [
            "Innospeq is a web-based software platform for workplace safety that assists with safety inspections and risk assessments, among other things. The goal is to use AI to relieve specialized staff of routine tasks.",
            "During workplace safety inspections, for example, photos can be analyzed using AI in accordance with relevant regulations. The analysis results include identified hazards, recommended protective measures, and references to the corresponding legal requirements.",
            "The analysis results generated by the AI serve as suggestions and can be edited, supplemented, or deleted at any time. Final approval is granted by a qualified professional.",
            "The specific protective measures derived from these results can be systematically tracked. In addition, clear PDF reports and analyses can be generated automatically.",
            "The AI also provides significant support to users in their daily work across other application areas.",
          ],
        },
        {
          question: "Does innospeq’s AI replace a workplace safety specialist?",
          answer: [
            "innospeq’s AI analyzes the data based on relevant legal and technical requirements.",
            "The analysis results generated by the AI serve as suggestions and can be edited, supplemented, or deleted at any time. Despite the high quality of the results, there may be instances where certain issues are not recognized, are incorrectly assessed, or are otherwise misjudged. Therefore, a final review and approval by a qualified professional is required. Responsibility remains with the responsible professional or the company.",
            "innospeq therefore does not replace an occupational safety specialist, but rather provides support in carrying out and documenting these tasks.",
          ],
        },
        {
          question: "Which regulations are taken into account?",
          answer: [
            "innospeq takes into account the BAuA’s Technical Rules, DGUV regulations, and German and European legal provisions.",
            "When hazards are identified, the detailed legal background is provided.",
          ],
        },
        {
          question: "Where is data stored, and how are images protected?",
          answer: [
            "All of innospeq’s servers are located within the European Union. If you are interested, we would be happy to provide you with detailed information on this. The protection of your data is particularly important to us.",
            "Captured images are scanned for faces at the start of processing, and any faces detected are then blurred.",
            "Uploaded images, documents, and project data are processed exclusively to provide the agreed-upon features and are not used for general training of AI models.",
          ],
        },
        {
          question:"What should I keep in mind when taking photos?",
          answer: [
            "The more clearly a potential hazard is visible in the photo, the better the AI can analyze it. Photos should therefore focus as directly as possible on relevant areas, equipment, or specific issues.",
            "Wide-angle photos that simply show a room from a distance are usually less useful for the analysis. Clearer, closer shots that make the situation easy to recognize work better. If necessary, several photos can also be taken from different angles.",
            "People may appear in the images. In some situations, this can even support the analysis, for example when posture, working methods, or the handling of equipment are relevant. Faces are anonymized before the AI analysis takes place.",
          ],
        },
        {
          question:"Why does innospeq analyze images instead of videos?",
          answer: [
            "Video analysis is a separate use case focused on verifying in real time whether safety measures are being followed—such as whether the required personal protective equipment (PPE) is being worn or whether forklifts are operating with their forks lowered.",
            "innospeq, on the other hand, focuses on identifying hazards early on and deriving appropriate protective measures.",
          ],
        },
        {
          question: "Which devices and browsers are supported? Does an app need to be installed?",
          answer: [
            "innospeq is a web application that works in all modern browsers. No separate installation is required on a computer, tablet, or smartphone.",
            "The application can be used on both desktop and mobile devices. On a smartphone, photos can be taken directly within innospeq and analyzed immediately, allowing inspections to be carried out and documented on site.",
          ],
        },
        {
          question: "Can custom checklists and templates be created?",
          answer: [
            "Yes. Custom checklists can be adapted to internal processes, locations, and individual inspection requirements.",
            "Existing documents, such as PDF or Word files, can be used as the basis for new templates. Alternatively, checklists can be created with LexHub and then customized further.",
            "In addition to checklists, innospeq supports safety inspections and structured risk assessments as dedicated project types.",
          ],
        },
        {
          question: "Can tasks be managed and assigned to team members?",
          answer: [
            "Yes. Specific tasks and protective measures are derived from documented hazards.",
            "For each task, a responsible person, a deadline, and a status can be specified. Tasks are clearly displayed in the “To Do,” “In Progress,” and “Done” sections. Overdue, pending, and completed tasks are immediately recognizable.",
            "In the “My Tasks” section, all personally assigned tasks are consolidated in one central location across all projects.",
          ],
        },
        {
          question: "Can reports be customized for the company?",
          answer: [
            "Yes. The standard report can be customized with the company's own logo.",
            "If additional content, structures, or layouts are required, the innospeq team can create custom report templates and make them available directly within the application.",
            "Reports can include a title, description, affected areas, responsible people, and additional participants, among other details. Users can also choose whether to include protective measures and mark the report as reviewed and approved. The finished report is generated as a PDF.",
          ],
        },
        {
          question: "Can innospeq be tested before purchase?",
          answer: [
            "Yes, we are confident in our product and welcome anyone who would like to test innospeq. To request a guided proof of concept or trial access, please contact the innospeq team directly through the Contact section of the website.",
            "During the trial, you can explore the core features in your own work environment—from capturing and analyzing images to addressing identified hazards, managing protective measures, and generating a PDF report.",
          ],
          cta: { label: "Request trial access", href: "#contact" },
        },
      ],
    },
    contact: {
      eyebrow: "Free demo",
      title: "See Innospeq in action.",
      desc: "Drop us a line – we'll get back to you within one business day.",
      name: "Name",
      namePh: "Your full name",
      email: "Email",
      emailPh: "name@company.com",
      phone: "Phone",
      phonePh: "(0123) 456-7890",
      message: "Message",
      messagePh: "What would you like to discuss?",
      submit: "Send request",
      submitting: "Sending…",
      success: "Thank you! We'll be in touch shortly.",
      consent: "By submitting you agree to our privacy policy.",
      info: [
        { label: "Email", value: "info@innospeq.com" },
        { label: "Location", value: "Germany" },
        { label: "Response", value: "< 24h" },
      ],
    },
    footer: {
      tagline: "AI-powered safety inspections for modern companies.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: {
        features: "Features",
        pricing: "Pricing",
        app: "Go to app",
        about: "About",
        linkedin: "Find us on LinkedIn",
        careers: "Careers",
        disclaimer: "Disclaimer",
        privacy: "Privacy",
        imprint: "Imprint",
        terms: "Terms",
      },
      rights: "All rights reserved.",
    },
    pricing: {
      back: "Back",
      eyebrow: "Pricing",
      title: "Plans for individuals and organizations.",
      lead: "Choose the right starting point for digital safety inspections, AI-powered evaluations and transparent action tracking.",
      badge: "Popular",
      introductoryPrice: "Introductory price",
      included: "Included",
      features: "Features",
      plans: [
        {
          name: "Core",
          ideal: "Ideal for individual safety officers",
          price: "€69",
          period: "per month / editor user",
          cta: "Request demo",
          href: "/#contact",
          primary: true,
          features: [
            { label: "Users", value: "1 editor user" },
            { label: "Projects", value: "25 projects" },
            { label: "Image analyses", value: "100 image analyses / month included" },
            { label: "AI features", value: "AI-powered image analysis" },
            { label: "Administration & security", value: "Basic administration & security features" },
            { label: "Support", value: "Standard support" },
          ],
        },
        {
          name: "Enterprise",
          ideal: "Ideal for organizations & multiple sites",
          price: "€199",
          period: "per month / editor user",
          cta: "Request demo",
          href: "/#contact",
          primary: true,
          features: [
            { label: "Users", value: "Custom agreement + unlimited viewer users" },
            { label: "Projects", value: "Unlimited projects" },
            { label: "Image analyses", value: "400 image analyses / month included" },
            { label: "AI features", value: "AI agent + recommendations based on relevant standards and regulatory frameworks" },
            { label: "Administration & security", value: "SSO, audit trail, private instance" },
            { label: "Support", value: "Premium support with a personal contact" },
          ],
        },
      ],
      note: "If none of the plans is suitable for your needs, we offer custom solutions. Please contact us to discuss your requirements.",
      addOns: {
        title: "Add-on packages",
        desc: "Optional image analysis packages available for both plans.",
        items: [
          { label: "+100 image analyses", value: "€49", rate: "(€0,49 / image)" },
          { label: "+500 image analyses", value: "€225", rate: "(€0,45 / image)" },
          { label: "+1,000 image analyses", value: "€390", rate: "(€0,39 / image)" },
        ],
      },
      comparison: {
        title: "Compare plans",
        rows: [
          { label: "Usage & limits", section: true },
          // { label: "Price", core: "€69 / month / user", enterprise: "€999 / month / location" },
          { label: "Editor users", core: "1 active user", enterprise: "Individually agreed" },
          { label: "Viewer users", core: "minus", enterprise: "Unlimited" },
          { label: "Projects", core: "25", enterprise: "Unlimited" },
          { label: "Image analyses per month", core: "100 / month", enterprise: "400 / month" },
          { label: "Price per image analysis", core: "€0.69 / image", enterprise: "€0.50 / image" },
          { label: "Image analysis add-ons", core: "check", enterprise: "check" },

          { label: "Inspections & defect management", section: true },
          { label: "Risk-focused safety inspections", core: "check", enterprise: "check" },
          { label: "Checklists", core: "check", enterprise: "check" },
          { label: "Custom checklist templates", core: "check", enterprise: "check" },
          { label: "Capture defects and assign tasks", core: "check", enterprise: "check" },
          // { label: "External defect assignment", core: "check", enterprise: "minus" },
          { label: "Automatic duplicate detection", core: "check", enterprise: "check" },
          { label: "PDF reports", core: "check", enterprise: "check" },
          { label: "Face anonymization", core: "check", enterprise: "check" },
          { label: "Email notifications", core: "check", enterprise: "check" },

          { label: "AI & regulatory intelligence", section: true },
          { label: "AI-powered image analysis", core: "check", enterprise: "check" },
          { label: "Recommendations based on relevant standards and regulations", core: "check", enterprise: "check" },
          { label: "AI agent for Enterprise", core: "minus", enterprise: "check" },
          { label: "Risk assessments", core: "minus", enterprise: "Coming soon" },

          { label: "Analytics", section: true },
          { label: "Project analytics", core: "check", enterprise: "check" },
          { label: "Location-wide and organization-wide analytics", core: "minus", enterprise: "check" },

          { label: "Security & organization", section: true },
          { label: "Google sign-in", core: "check", enterprise: "check" },
          { label: "Microsoft Entra ID SSO", core: "minus", enterprise: "check" },
          // { label: "Roles / viewers / editors", core: "check", enterprise: "check" },
          { label: "Change history / audit trail", core: "minus", enterprise: "check" },
          { label: "Hierarchical organization structure", core: "minus", enterprise: "check" },
          { label: "Share projects", core: "minus", enterprise: "check" },
          { label: "Private cloud instance", core: "minus", enterprise: "check" },
          { label: "On-premises by arrangement", core: "minus", enterprise: "check" },
          { label: "All new features automatically included", core: "minus", enterprise: "check" },

          { label: "Support", section: true },
          { label: "Standard support", core: "check", enterprise: "check" },
          { label: "Premium support with a dedicated contact person", core: "minus", enterprise: "check" },
        ],
      },
    },
    about: {
      back: "Back",
      eyebrow: "About us",
      title: "We build safety processes that work in everyday operations.",
      company: {
        title: "About our company",
        copy: [
          "Innospeq develops digital tools for modern workplace safety. Our focus is making safety inspections simpler, faster and more reliable.",
          "We combine AI-powered image analysis, clear documentation and transparent action tracking into one platform that supports teams in daily operations.",
        ],
      },
      team: {
        eyebrow: "Our team",
        title: "Five perspectives, one shared goal.",
        lead: "Our team combines product thinking with technical depth.",
        members: [
          {
            title: "Daniel Bettenworth, CEO",
            description: "Sets the strategic direction and keeps Innospeq close to the real needs of our customers.",
            alt: "Portrait of management",
          },
          {
            title: "Jens Dünnermann, AI & Engineering",
            description: "Develops the analysis features and technical platform behind our automated inspections.",
            alt: "Portrait of product management",
          },
          {
            title: "Patrick Walczok, AI & Engineering",
            description: "Builds the analysis features and technical platform behind our automated inspections.",
            alt: "Portrait of AI and engineering",
          },
          {
            title: "Isabel Pfab, Design",
            description: "Shapes the user experience and ensures that complex safety processes are translated into clear, intuitive workflows.",
            alt: "Portrait of workplace safety",
          },
          {
            title: "Tom Rudolph, Go-to-Market & Growth",
            description: "Drives conversations with the right companies, develops new market opportunities and builds customer relationships from first contact to successful onboarding.",
            alt: "Portrait of customer success",
          },
        ],
      },
    },
    imprint: {
      back: "Back",
      eyebrow: "Legal",
      title: "Imprint",
      sections: [
        {
          title: "Provider",
          lines: [
            "Innospeq GmbH",
            "Managing Director Daniel Bettenworth",
            "Falkenrecks Heide 22",
            "33332 Gütersloh",
            "Germany",
          ],
        },
        {
          title: "Contact",
          lines: ["Phone: +49 (0)5241 2118216", "Email: info@innospeq.com"],
        },
        {
          title: "Registration details",
          lines: [
            "VAT ID: DE460504564",
            "Commercial register of the Local Court of Gütersloh",
            "Commercial register number: HRB 14373",
          ],
        },
      ],
      additionalSections: [
        {
          title: "EU dispute resolution",
          paragraphs: [
            "The European Commission provides a platform for online dispute resolution (ODR):",
            "You can find our email address above in this imprint.",
          ],
          link: {
            label: "https://ec.europa.eu/consumers/odr/",
            href: "https://ec.europa.eu/consumers/odr/",
          },
        },
        {
          title: "Consumer dispute resolution/universal arbitration board",
          paragraphs: [
            "We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
          ],
        },
        {
          title: "Liability for content",
          paragraphs: [
            "As a service provider, we are responsible for our own content on these pages in accordance with Section 7 (1) TMG and general law. According to Sections 8 to 10 TMG, however, we are not obliged to monitor transmitted or stored third-party information or investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law remain unaffected by this.",
            "Liability in this regard is only possible from the time we become aware of a specific infringement. Upon becoming aware of such legal violations, we will remove this content immediately.",
          ],
        },
        {
          title: "Liability for links",
          paragraphs: [
            "Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the linked pages is always responsible for their content. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. Permanent monitoring of the content of linked pages is not reasonable without concrete evidence of a violation. Upon becoming aware of violations, we will remove such links immediately.",
          ],
        },
        {
          title: "Copyright",
          paragraphs: [
            "The content and works created by the site operators on these pages are subject to German copyright law. Reproduction, editing, distribution, and any kind of use outside the limits of copyright law require the written consent of the respective author or creator. Downloads and copies of this site are permitted for private, non-commercial use only. Insofar as the content on this site was not created by the operator, third-party copyrights are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. Upon becoming aware of legal violations, we will remove such content immediately.",
          ],
        },
      ],
    },
    privacy: {
      back: "Back",
      eyebrow: "Legal",
      title: "Privacy Policy",
      sections: [
        {
          title: "1. Controller",
          lines: [
            "Innospeq GmbH",
            "Falkenrecks Heide 22",
            "33332 Gütersloh",
            "Germany",
            "Email: info@innospeq.de",
          ],
        },
        {
          title: "2. General information",
          paragraphs: [
            "Protecting your personal data is important to us. We treat personal data confidentially and in accordance with statutory data protection regulations and this privacy policy.",
            "Personal data means any data that can be used to personally identify you.",
          ],
        },
        {
          title: "3. Data collected when visiting the website",
          paragraphs: [
            "When you access our website, the server automatically records the following data:",
          ],
          items: [
            "IP address",
            "Date and time of access",
            "Page accessed",
            "Browser type and version",
            "Operating system",
            "Referrer URL",
          ],
        },
        {
          title: "Technical delivery",
          paragraphs: [
            "This data is technically necessary to deliver the website correctly and to ensure the stability and security of the system.",
            "Legal basis: Art. 6 (1) lit. f GDPR",
          ],
        },
        {
          title: "4. Hosting",
          paragraphs: [
            "Our website is operated on our own servers, which are rented from IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Germany.",
            "A data processing agreement pursuant to Art. 28 GDPR is in place.",
          ],
        },
        {
          title: "5. Contact form",
          paragraphs: [
            "If you contact us via the contact form, your name, email address and message will be processed.",
            "The information is transmitted by email and is used exclusively to process your request.",
            "Legal basis:",
          ],
          items: [
            "Art. 6 (1) lit. b GDPR",
            "Art. 6 (1) lit. f GDPR",
          ],
        },
        {
          title: "6. Cookies",
          paragraphs: [
            "No analytics or marketing cookies are used.",
          ],
        },
        {
          title: "7. Rights of data subjects",
          paragraphs: [
            "You have the right to access, rectification, erasure, restriction of processing, data portability and objection.",
          ],
        },
        {
          title: "8. Status",
          paragraphs: ["Last updated: July 7, 2026"],
        },
      ],
    },
    disclaimer: {
      back: "Back",
      eyebrow: "Legal",
      title: "Disclaimer for AI-based assessments (innospeq)",
      intro: [
        "The evaluations, assessments and recommendations provided by innospeq are generated using artificial intelligence (AI) methods. They are intended solely to support users and do not replace expert advice or a decision by a qualified human expert.",
      ],
      subheading: "In particular",
      items: [
        "AI results do not constitute legally binding information or a final professional assessment.",
        "Before any professional, organizational or legally relevant decision is made, the assessments generated by innospeq must be reviewed, evaluated in terms of content and approved by a suitably qualified person, such as a specialist or expert in the relevant field or a responsible manager.",
        "Direct or automated implementation of AI results without human review is impermissible and takes place outside the area of responsibility of innospeq.",
        "To the extent permitted by law, innospeq assumes no liability for damages arising from the use or implementation of AI-based evaluations or recommendations without appropriate human review, assessment and approval. Mandatory statutory liability remains unaffected.",
      ],
    },
  },
};
